
import {initWebComponent} from "@/helpers/web-component-helper";
import {hideAllInfo, hideLayerInfoForm} from "@/helpers/layer/info/layer-info-helper";
import {setKeyIsRightMouseButton} from "@/helpers/right-mouse-button-helper";

const template = document.createElement('template');
template.innerHTML = `<header-button data-icon="fa fa-external-link-alt" data-tooltip="openRightMouseButton"></header-button>`;

export class HeaderRightMouseButtonComponent extends HTMLElement {
    constructor(){
        super();
        initWebComponent(this, template)

        this.addEventListener('click', () => {
            setKeyIsRightMouseButton(false)
            const element = document.querySelectorAll('bookmark-right-mouse-button')[0]
            const classList = [...element.classList]
            hideLayerInfoForm()

            if(classList.includes('d-none')) {
                element.classList.remove('d-none')
                element.parentNode.classList.remove('d-none')
            } else {
                hideAllInfo()
            }
        });
    }
}

